import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useInput } from '../../hooks/useInput'
import {
  Button,
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@material-ui/core'
import MultiFilesInput from '../Form/MultiFilesInput'
import FileUploadTable from '../Form/FileUploadTable'
import TextAreaInput from '../Form/TextAreaInput'
import pdf from '../../assets/pdf/example.pdf'
import FormContainer from '../Form/FormContainer'
import { updateProject } from '../../actions/projectActions'
import { PROJECT_UPDATE_RESET } from '../../constants/projectConstants'
import Loader from '../Loader/Loader'

const EditReport = ({ setShowEditReport, index }) => {
  const dispatch = useDispatch()
  const [reportSet, setReportSet] = useState(false)
  const [files, setFiles] = useState([])
  const [filesUploading, setFilesUploading] = useState([])
  const [filesError, setFilesError] = useState('')
  const {
    value: comments,
    bind: bindComments,
    error: commentsError,
    setError: setCommentsError,
    setValue: setComments,
  } = useInput('')
  const [reportType, setReportType] = useState('Standard')

  const { loading: loadingUpdate, success: successUpdate } = useSelector(
    (state) => state.projectUpdate
  )
  const { project } = useSelector((state) => state.projectDetails)

  useEffect(() => {
    if (!reportSet) {
      const report = project.requests[index].report
      setReportType(report.reportType)
      setComments(report.comments)
      setFiles(report.files)
      setReportSet(true)
    }
  }, [reportSet, project, index, setReportType, setComments])

  useEffect(() => {
    if (successUpdate) {
      setShowEditReport(false)
      dispatch({ type: PROJECT_UPDATE_RESET })
    }
  }, [successUpdate, dispatch, setShowEditReport])

  const formIsReady = () => {
    let ready = true
    if (reportType !== 'Standard' && comments === '') {
      setCommentsError('Please enter your customization requirements.')
      ready = false
    }

    return ready
  }

  const submitHandler = () => {
    if (formIsReady()) {
      addRequestToProject()
    }
  }

  const addRequestToProject = () => {
    let projectClone = project

    project.requests[index].report = { reportType, comments, files }

    dispatch(updateProject(projectClone))
  }

  return (
    <>
      <FormContainer>
        <div className="m-b-30">
          <h4>Report requirements</h4>
        </div>

        <FormControl component="fieldset">
          <RadioGroup
            aria-label="report type"
            name="reportType"
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
          >
            <FormControlLabel
              value="Standard"
              control={<Radio />}
              label={
                <div>
                  Standard report.{' '}
                  <a
                    className="link"
                    href={pdf}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    See example.
                  </a>
                </div>
              }
            />
            <FormControlLabel
              value="Partial Custom"
              control={<Radio />}
              label="Partial customization (enter requirements below in comment field)"
            />
            <FormControlLabel
              value="Full Custom"
              control={<Radio />}
              label="Full customization (enter requirements below in comment field)"
            />
          </RadioGroup>
        </FormControl>

        <TextAreaInput
          className="m-b-16"
          name="comments"
          label="Comments"
          bindValue={bindComments}
          rows={4}
          error={commentsError}
        />

        <MultiFilesInput
          name="files"
          label="Files"
          filesUploading={filesUploading}
          setFiles={setFiles}
          setFilesUploading={setFilesUploading}
          contentTop={
            <>
              Drag and drop or click to add
              <strong> reference files</strong>
            </>
          }
          contentBottom="Please include header, footer, and logo files if customization required"
          error={filesError}
          setError={setFilesError}
        />

        {(files.length > 0 || filesUploading.length > 0) && (
          <FileUploadTable
            data={files}
            setData={setFiles}
            filesUploading={filesUploading}
          />
        )}

        <div className="actions m-t-40 flex flex-end">
          <div>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setShowEditReport(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={loadingUpdate}
              style={{ marginLeft: 20 }}
              onClick={submitHandler}
            >
              {loadingUpdate ? <Loader /> : 'Save'}
            </Button>
          </div>
        </div>
      </FormContainer>
    </>
  )
}

export default EditReport
